import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { ArrowsClockwise, FileXls, CheckCircle, XCircle, Clock, Warning } from '@phosphor-icons/react';

const STATUS_BADGE = {
  verzonden_via_ap: { bg: '#ECFDF5', fg: '#047857', icon: <CheckCircle size={10} weight="fill" />, label: 'Verzonden via Access Point' },
  xml_ready: { bg: '#EFF6FF', fg: '#1E40AF', icon: <FileXls size={10} weight="fill" />, label: 'XML gegenereerd (manueel uploaden)' },
  verzonden: { bg: '#ECFDF5', fg: '#047857', icon: <CheckCircle size={10} weight="fill" />, label: 'Verzonden (legacy)' },
  ap_connection_error: { bg: '#FEF2F2', fg: '#B91C1C', icon: <XCircle size={10} weight="fill" />, label: 'Verbindingsfout Access Point' },
};

export default function PeppolLogViewer() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    API.get('/dashboard/peppol-log', { params: { limit: 100 } })
      .then(r => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="section-card" data-testid="peppol-log-viewer">
      <div className="section-header flex items-center justify-between">
        <span className="section-title">Peppol verzend-log</span>
        <button
          type="button"
          onClick={load}
          className="text-[11px] text-gray-500 hover:text-gray-700 flex items-center gap-1"
          data-testid="peppol-log-reload"
        >
          <ArrowsClockwise size={12} weight="bold" /> Ververs
        </button>
      </div>
      <div className="p-4">
        {loading ? (
          <div className="text-sm text-gray-400">Laden...</div>
        ) : items.length === 0 ? (
          <div className="text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded p-4 text-center">
            <Clock size={24} className="mx-auto mb-2 text-gray-400" />
            Nog geen Peppol-verzendingen geregistreerd.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="data-table text-xs">
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Document</th>
                  <th>Ontvanger</th>
                  <th>Status</th>
                  <th>Response</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it, i) => {
                  const badge = STATUS_BADGE[it.status] || { bg: '#F3F4F6', fg: '#374151', icon: <Warning size={10} />, label: it.status || '-' };
                  const dt = it.aangemaakt_at ? new Date(it.aangemaakt_at) : null;
                  return (
                    <tr key={i} data-testid={`peppol-log-row-${i}`}>
                      <td className="font-mono text-[10px] text-gray-500">
                        {dt ? `${dt.toLocaleDateString('nl-BE')} ${dt.toLocaleTimeString('nl-BE', { hour: '2-digit', minute: '2-digit' })}` : '-'}
                      </td>
                      <td className="font-mono font-bold">{it.doc_id || '-'}</td>
                      <td className="text-gray-700">{it.correspondent || '-'}</td>
                      <td>
                        <span
                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold"
                          style={{ background: badge.bg, color: badge.fg }}
                        >
                          {badge.icon} {badge.label}
                        </span>
                      </td>
                      <td className="text-[10px] text-gray-500 font-mono max-w-md truncate" title={it.ap_response || ''}>
                        {it.ap_response || it.omschrijving || '-'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
